import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getAnuncio } from '../../../services/apiAnuncio';
import { getImagens } from '../../../services/apiImagem';
import { getUsuario, getUsuarioDadoPublico } from '../../../services/apiUsuario';
import { getToken } from '../../../services/api';
import { getFavorito, postFavorito, deleteFavorito } from '../../../services/apiFavorito';
import { getCondicaoCd } from '../../../services/apiCondicao';
import './visualizarAnuncio.css';
import 'react-image-gallery/styles/css/image-gallery.css';
import ImageGallery from 'react-image-gallery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faTag, faHandHoldingDollar } from '@fortawesome/free-solid-svg-icons';
import Spinner from 'react-bootstrap/Spinner';
import { Helmet } from 'react-helmet';
import imagemPadrao from '../../../shared/assets/logoCard.svg';
import AcoesAnuncio from '../../../components/acoesAnuncio/AcoesAnuncio';
import { useAuth } from '../../../context/AuthContext';
import { getCategoria } from '../../../services/apiCategoria';
import { sucessoToastify } from '../../../shared/validacaoToastify';
import { toast } from 'react-toastify';

interface Anuncio {
    cdAnuncio: number;
    nmAnuncio: string;
    dtPublicacao: Date;
    dsAnuncio: string;
    dmAtivo: boolean;
    vlAnuncio: number;
    nrAnunciada?: number;
    cdUsuario: number;
    cdCategoria: number;
    dmSituacao: boolean;
    cdModelo?: number | null;
    cdCidade: number;
    cdCondicao?: number | null;
    dmTipoAnuncio: boolean;
    dtInclusao: Date;
    dtAlteracao?: Date | null;
    cdUsuarioAlt?: number | null;
    cdUsuarioInc: number;
    nmSigla: string;
    nmCidade: string;
    imagens: { id: number; url: string }[];
}

interface Condicao {
    cdCondicao: number | string;
    nmCondicao: string;
}

interface Categoria {
    cdCategoria: number | string;
    nmCategoria: string;
}

interface Usuario {
    nmUsuario: string;
    nmEmail: string;
    dsContato: string;
    dsContatoOpcional?: string;
}

interface ImagemData {
    cdImagem: number;
    cdAnuncio: number;
    nmTipoArquivo: string;
    dsArquivoImagem: string;
    dsLinkVideo: string;
    mdArquivo: string;
    cdUsuarioInc: number;
    cdUsuarioAlt: number;
    dtInclusao: string;
    dtAlteracao: string;
    dmSituacao: boolean;
}

interface Favorito {
    cdAnuncio: number;
    cdFavorito: number;
}

export default function VisualizarAnuncio() {
    const { id } = useParams<{ id?: string }>();
    const [anuncio, setAnuncio] = useState<Anuncio | null>(null);
    const [condicao, setCondicao] = useState<Condicao | null>(null);
    const [categoria, setCategoria] = useState<Categoria | null>(null);
    const [dadosUsuario, setDadosUsuario] = useState<Usuario | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [favoritado, setFavoritado] = useState<boolean>(false);
    const [cdFavorito, setCdFavorito] = useState<number | null>(null);
    const [imagens, setImagens] = useState<ImagemData[]>([]);
    const [loadingAnuncio, setLoadingAnuncio] = useState<boolean>(true);
    const [loadingImagens, setLoadingImagens] = useState<boolean>(true);
    const [token, setToken] = useState<string | null>(null);
    const cdUsuarioLocal = parseInt(localStorage.getItem('cdUsuario') || '0', 10);
    const cdPerfilLocal = parseInt(localStorage.getItem('cdPerfil') || '0');
    const { isAuthenticated, user, login } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    const usuarioAutenticado = user?.cdUsuario.toString() === anuncio?.cdUsuario.toString();

    useEffect(() => {
        if (id) {
            const fetchAnuncio = async () => {
                try {
                    const response = await getAnuncio(id);
                    setAnuncio(response);
                    const usuarioResponsePublic = await getUsuarioDadoPublico(response.cdUsuario);
                    setDadosUsuario(usuarioResponsePublic.data);
                    setLoadingAnuncio(false);
                } catch (error) {
                    console.error("Erro ao carregar o anúncio:", error);
                    setLoadingAnuncio(false);
                }
            };
            fetchAnuncio();
        }
    }, [id, user]);

    useEffect(() => {
        const fetchCondicao = async () => {
            try {
                if (anuncio?.cdCondicao) {
                    const responseCondicao = await getCondicaoCd(+anuncio?.cdCondicao)
                    setCondicao(responseCondicao.data);
                }
            } catch (error) {
                console.error("Erro ao carregar a condição:", error);
            }
        }
        fetchCondicao()

        const fetchCategorias = async () => {
            try {
                if (anuncio?.cdCategoria) {
                    const responseCategoria = await getCategoria(+anuncio?.cdCategoria);
                    setCategoria(responseCategoria.data);
                }
            } catch (error) {
                console.error("Erro ao carregar a categoria:", error);
            }
        }
        fetchCategorias()
    }, [anuncio?.cdCondicao, anuncio?.cdCategoria])

    useEffect(() => {
        const buscarImagens = async () => {
            if (anuncio) {
                try {
                    const imagensData = await getImagens('1');
                    const imagensFiltradas = imagensData.filter((imagem: ImagemData) => imagem.cdAnuncio === anuncio.cdAnuncio);
                    imagensFiltradas.sort((a: any, b: any) => new Date(a.dtInclusao).getTime() - new Date(b.dtInclusao).getTime());
                    setImagens(imagensFiltradas);
                    setLoadingImagens(false);
                } catch (error) {
                    console.error('Erro ao obter imagens:', error);
                    setLoadingImagens(false);
                }
            }
        };

        buscarImagens();
    }, [anuncio]);


    useEffect(() => {
        const verificarFavorito = async () => {
            if (id && cdUsuarioLocal) {
                try {
                    if (isAuthenticated) {
                        const favoritoResponse: any = await getFavorito(cdUsuarioLocal.toString());
                        const anuncioFavoritado = favoritoResponse.data.find((fav: Favorito) => fav.cdAnuncio === parseInt(id));
                        if (anuncioFavoritado) {
                            setFavoritado(true);
                            setCdFavorito(anuncioFavoritado.cdFavorito);
                        }
                    }
                } catch (error) {
                    console.error('Erro ao verificar se o anúncio é favoritado:', error);
                }
            }
        };

        verificarFavorito();
    }, [id, cdUsuarioLocal, favoritado, isAuthenticated]);

    const precoFormatado = (preco: number) => {
        return `R$ ${preco.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    const favoritarAnuncio = async () => {
        if (!anuncio) return;

        try {
            const cdUsuario = localStorage.getItem('cdUsuario') || '0';
            const dtAtual = new Date().toISOString();

            const data = {
                cdFavorito: 0,
                cdUsuario: parseInt(cdUsuario),
                cdAnuncio: anuncio.cdAnuncio,
                dtSelecao: dtAtual,
                cdUsuarioInc: parseInt(cdUsuario),
                cdUsuarioAlt: parseInt(cdUsuario),
                dtInclusao: dtAtual,
                dtAlteracao: dtAtual,
                dmSituacao: true
            };

            const response = await postFavorito(data);
            setFavoritado(true);
            setCdFavorito(response.data.cdFavorito);
        } catch (error) {
            console.error('Erro ao favoritar anúncio:', error);
        }
    };

    const desfavoritarAnuncio = async () => {
        if (!anuncio || !cdFavorito) return;

        try {
            const cdUsuario = localStorage.getItem('cdUsuario') || '0';
            const dtAtual = new Date().toISOString();

            const data = {
                cdFavorito: cdFavorito,
                cdUsuario: parseInt(cdUsuario),
                cdAnuncio: anuncio.cdAnuncio,
                dtSelecao: dtAtual,
                cdUsuarioInc: parseInt(cdUsuario),
                cdUsuarioAlt: parseInt(cdUsuario),
                dtInclusao: dtAtual,
                dtAlteracao: dtAtual,
                dmSituacao: false
            };
            await deleteFavorito({ data });
            setFavoritado(false);
            setCdFavorito(null);
        } catch (error) {
            console.error('Erro ao desfavoritar anúncio:', error);
        }
    };

    const formatarTelefone = (numero: string) => {
        if (numero.length === 11) {
            return `(${numero.slice(0, 2)}) ${numero.slice(2, 7)}-${numero.slice(7)}`;
        } else if (numero.length === 10) {
            return `(${numero.slice(0, 2)}) ${numero.slice(2, 6)}-${numero.slice(6)}`;
        }
        return numero;
    };

    const images = imagens.length > 0 ? imagens.map(imagem => ({
        original: `data:image/${imagem.nmTipoArquivo};base64,${imagem.mdArquivo}`,
        thumbnail: `data:image/${imagem.nmTipoArquivo};base64,${imagem.mdArquivo}`,
    })) : [{
        original: imagemPadrao,
        thumbnail: imagemPadrao,
    }];


    useEffect(() => {

    }, [favoritado])

    return (
        <div className='containerVisualizarAnuncio'>
            <Helmet>
                <title>{anuncio?.nmAnuncio}</title>
            </Helmet>
            {loadingAnuncio || loadingImagens ? (
                <div className='spinner-container'>
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Carregando...</span>
                    </Spinner>
                </div>
            ) : (
                <>
                    <div className="containerCardVisualizarAnuncio mt-5" style={isAuthenticated ? {} : { gap: '20px' }}>
                        <div className="cardAnuncio">
                            <div className="dadosAnuncioVisualizar">
                                <p>Publicado em {new Date(anuncio!.dtPublicacao).toLocaleDateString()} - {anuncio!.dmTipoAnuncio ? 'Produto' : 'Serviço'}</p>
                            </div>
                            <div className="nmAnuncioVisualizar">
                                <p>{anuncio!.nmAnuncio}</p>
                            </div>
                            <div className="cardImgAnuncio">
                                <ImageGallery items={images} showThumbnails={true} />
                            </div>
                            <div className="secaoPrecoFavoritoVisualizarAnuncio">
                                <span>{precoFormatado(anuncio!.vlAnuncio)}</span>
                                {!usuarioAutenticado && isAuthenticated && <FontAwesomeIcon
                                    icon={faHeart}
                                    size={'xl'}
                                    color={favoritado && isAuthenticated ? '#7B0323' : 'grey'}
                                    onClick={favoritado && isAuthenticated ? desfavoritarAnuncio : favoritarAnuncio}
                                    className='iconeFavoritar'
                                    style={{ 'cursor': 'pointer' }}
                                />}

                                {usuarioAutenticado && isAuthenticated && <div className='meuAnuncio'> <FontAwesomeIcon
                                    icon={faTag}
                                    color={'#eb9b00'}
                                /> <p >Criado por você!</p> </div>}
                            </div>
                            <div className="secaoDescricaoVisualizarAnuncio">
                                <span>Descrição:</span>
                                <p>{anuncio!.dsAnuncio}</p>
                            </div>
                            {anuncio?.dmTipoAnuncio && (
                                <>
                                    <div className="secaoQuantidadeVisualizarAnuncio">
                                        <span>Quantidade:</span>
                                        <p> {anuncio.nrAnunciada}</p>
                                    </div>
                                    <div className="secaoQuantidadeVisualizarAnuncio">
                                        <span>Condição:</span>
                                        <p>{condicao?.nmCondicao}</p>
                                    </div>
                                    <div className="secaoQuantidadeVisualizarAnuncio">
                                        <span>Categoria:</span>
                                        <p>{categoria?.nmCategoria}</p>
                                    </div>
                                </>
                            )}

                        </div>
                        <div className='boxUsuario'>
                            <div className="acoesAnuncio">
                                {anuncio && (anuncio.cdUsuario === cdUsuarioLocal || cdPerfilLocal == 1) && (
                                    <AcoesAnuncio cdAnuncio={anuncio.cdAnuncio} dmAtivo={anuncio.dmAtivo} dtPublicacao={anuncio.dtPublicacao} />
                                )}
                            </div>
                            <div className="cardAnunciante">
                                <h3 className="titulo__anunciante">Dados do Anunciante</h3>
                                <hr className="linha__divisoria" />
                                <div className="container__dados">
                                    {dadosUsuario ? (
                                        <div>
                                            <p className="nome__anunciante">{dadosUsuario.nmUsuario}</p>
                                            <strong className="telefone__anunciante">
                                                <p>Telefone(s):</p>
                                            </strong>
                                            <p className='nrTelefoneUsuario'>{formatarTelefone(dadosUsuario.dsContato)}</p>
                                            {dadosUsuario.dsContatoOpcional && <p className='nrTelefoneUsuario'>{formatarTelefone(dadosUsuario.dsContatoOpcional)}</p>}
                                            <strong className="email__anunciante">
                                                <p>E-mail:</p>
                                            </strong>
                                            <p className='nmEmailUsuario'>{dadosUsuario.nmEmail}</p>
                                        </div>
                                    ) : (
                                        <div className='spinner-container'>
                                            <Spinner animation="border" role="status">
                                                <span className="sr-only">Carregando...</span>
                                            </Spinner>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
